import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'clmtlk-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  objDate = Date.now();
  
  constructor() { }

  

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/core/footer/footer.component.ts